import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppManagerService } from '../services/app-manager.service';

@Injectable()
export class ResultResponseInterceptor implements HttpInterceptor {
  constructor(private readonly appManagerService: AppManagerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((httpEvent) => {
        return httpEvent;
      }),
      catchError((errorResponse: HttpErrorResponse) => {
        // In caso di errore 401 si vede un messaggio specifico
        if (errorResponse.status === HttpStatusCode.Unauthorized) {
          this.appManagerService.showToastErrorMessageTranslated(errorResponse.error?.message);
        }

        // In caso di errore 403 si vede un messaggio specifico, in tal caso non propago l'errore
        if (errorResponse.status === HttpStatusCode.Forbidden) {
          this.appManagerService.showToastErrorMessageTranslated('error.forbidden');
          return EMPTY;
        }

        // const messageData = buildFromResultMessage(errorResponse.error, MessageLevel.Error);
        // this.appManagerService.showMessage(messageData);
        // Se l'errore ha idMessage ma non message, il componente che ha fatto la chiamata
        // gestisce già il messaggio via manageAndPrintError() con le proprie traduzioni.
        const errorMessageKey = errorResponse.error?.message;
        const skipToast = !errorMessageKey && !!errorResponse.error?.idMessage;
        if (!skipToast) {
          if (errorResponse.error?.translate === true || errorResponse.error?.translate === undefined) {
            this.appManagerService.showToastErrorMessageTranslated(errorMessageKey);
          } else {
            this.appManagerService.showToastErrorMessage(errorMessageKey);
          }
        }

        // http error handled(message shown) globally by interceptor
        // so set error to null
        //return throwError(null);
        return throwError(() => errorResponse);
      })
    );
  }
}
